import React, { useEffect, useRef, useState } from 'react';

import Appearance from 'styles/Appearance.js';
import TextField from 'views/TextField.js';
import Views, { AltBadge } from 'views/Main.js';

const FilePickerField = props => {

    const { accepted = ['*'], onChange, style, utils, value } = props;

    const fieldRef = useRef(null);
    const [file, setFile] = useState(null);
    const [label, setLabel] = useState('No file selected...');

    const onBrowseClick = () => {
        fieldRef.current.click();
    }

    const onFileChange = evt => {

        let { files } = evt.target;
        if(!files || files.length === 0) {
            return;
        }

        let file = files[0];
        const reader = new FileReader();
        reader.onload = data => {
            let next = {
                data: data.target.result,
                file_name: file.name,
                file_type: file.type
            }
            setFile(next);
            setLabel(next.file_name);
            if(typeof(onChange) === 'function') {
                onChange(next);
            }
        };
        reader.readAsDataURL(files[0]);
    }

    const onRemoveFile = () => {
        setFile(null);
        setLabel(null);
        if(typeof(onChange) === 'function') {
            onChange(null);
        }
    }

    const getAcceptedFileTypes = () => {
        return accepted.reduce((array, type) => {
            switch(type) {
                case 'txt':
                return array.concat([
                    'text/plain',
                    'public.plain-text'
                ]);

                case 'doc':
                case 'docx':
                return array.concat([
                    'application/msword',
                    'com.microsoft.word.doc',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ]);

                case 'pdf':
                return array.concat([
                    'application/pdf',
                    'com.adobe.pdf'
                ]);

                case 'xls':
                case 'xlsx':
                return array.concat([
                    'application/vnd.ms-excel',
                    'com.microsoft.excel.xls',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ]);

                default:
                return array;
            }
        }, []).join(', ');
    }

    useEffect(() => {
        setLabel(value ? value.file_name : null);
    }, [value]);

    return (
        <div style={{
            textAlign: 'left',
            width: '100%',
            ...style,
            height: 'auto'
        }}>
            <TextField
            {...props}
            icon={'file'}
            onClick={onBrowseClick}
            value={label}
            appendComponent={(
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row'
                }}>
                    <AltBadge
                    content={{
                        color: Appearance.colors.grey(),
                        text: 'Browse'
                    }} 
                    onClick={onBrowseClick}/>
                    {file && Views.icon.remove({ 
                        onClick: onRemoveFile,
                        overlay: false
                    })}
                </div>
            )}/>
            <input
            accept={getAcceptedFileTypes()}
            className={`custom-file-input ${window.theme}`}
            onChange={onFileChange}
            ref={fieldRef}
            style={{ display: 'none' }}
            type={'file'} />
        </div>
    )
}

export default FilePickerField;
